import { useMemo } from 'react'
import { EvidenceWrapper } from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { useCanPerformActionChecker } from 'src/app/AppAuth/AppAuth.hooks'

export const useEditableEvidenceDates = (
  evidence: EvidenceWrapper[],
): EvidenceWrapper[] => {
  const can = useCanPerformActionChecker()
  return useMemo(
    () =>
      evidence.filter(
        (item) =>
          (!item.getIsAutomated() || item.getIsLinkedDocument()) &&
          !!item.getEvidenceInstanceId() &&
          can(CAPABILITY.CAN_UPDATE_EVIDENCE_RELEVANT_DATE, item),
      ),
    [evidence, can],
  )
}
